module.exports = __webpack_public_path__ + "media/images/emblems/Herisau_gemeinde-3d416f694f24468da060b52cd22b67ac.png";